import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from "@material-ui/core";

const DeleteConfirmDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Confirmar exclusão</DialogTitle>
    <DialogContent>
      Deseja realmente excluir a regra?
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="default">
        Cancelar
      </Button>
      <Button onClick={onConfirm} color="secondary" variant="contained">
        Excluir
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmDialog;
